import { render, staticRenderFns } from "./AdministratorTools.vue?vue&type=template&id=3311537b"
import script from "./AdministratorTools.vue?vue&type=script&lang=js"
export * from "./AdministratorTools.vue?vue&type=script&lang=js"
import style0 from "./AdministratorTools.vue?vue&type=style&index=0&id=3311537b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports